import { render, staticRenderFns } from "./version.vue?vue&type=template&id=285feaec&"
import script from "./version.component.ts?vue&type=script&lang=ts&"
export * from "./version.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports